import { useTranslation } from 'react-i18next';
const BackImg = '/backgrounds/background-image-login.png';
import { ShieldCheck } from 'lucide-react';

function LoginLeftSection() {
  const { t } = useTranslation('login');

  return (
    <div className="hidden lg:flex lg:w-1/2 relative bg-gradient-to-br from-slate-900 to-slate-700">
      <img
        src={BackImg}
        alt="Secure"
        className="absolute inset-0 w-full h-full object-cover opacity-80"
      ></img>
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

      <div className="hidden absolute top-8 left-8 flex items-center gap-3 z-10">
        <div className="w-10 h-10 bg-surface rounded-lg flex items-center justify-center">
          <ShieldCheck
            size={24}
            className="text-lt-blue-600 w-6 h-6"
            strokeWidth={2}
          />
        </div>
        <span className="text-lt-white text-xl">{t('SLCAdmin')}</span>
      </div>

      <div className="hidden absolute bottom-16 left-8 right-8 z-10 text-lt-white">
        <h1 className="text-4xl mb-4">{t('secureDigitalTransactionsTitle')}</h1>
        <p className="text-lg text-lt-white/90 mb-6">
          {t('secureDigitalTransactionsSubtitle')}
        </p>
        <div className="flex gap-2">
          <div className="w-8 h-1 bg-lt-white rounded-full"></div>
          <div className="w-8 h-1 bg-lt-white/30 rounded-full"></div>
          <div className="w-8 h-1 bg-lt-white/30 rounded-full"></div>
        </div>
      </div>
    </div>
  );
}

export default LoginLeftSection;
